// extracted by mini-css-extract-plugin
export default {"MenuHidden":"_MenuHidden--dFWQU","EmptyFocusDivider":"_EmptyFocusDivider--OMVeK"};